import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { ModalAuctionUpdateEmailService } from '../../services/modal-auction-update-email/modal-auction-update-email.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuctionManageService } from '../../services/auction-manage/auction-manage.service';
import _ from 'lodash';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ConfirmModalComponent } from 'app/core/components/modals/confirm-modal/confirm-modal.component';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { updateBidder } from '../../features/auction.actions';
import { DonorService } from 'app/core/services/donor.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EmailNameSpliterService } from 'app/core/services/email-name-spliter.service';

@Component({
  selector: 'app-auction-update-bidder-modal',
  templateUrl: './auction-update-bidder-modal.component.html',
  styleUrls: ['./auction-update-bidder-modal.component.scss']
})
export class AuctionUpdateBidderModalComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input () data

  modalRef: MdbModalRef<ConfirmModalComponent> | null = null;

  public form: UntypedFormGroup = null;
  public nameInput: UntypedFormControl = null;
  public emailInput: UntypedFormControl = null;

  public isAddActive = false;
  public resultsOptions: Observable<string[]>;
  public notFound = false;

  private allProfiles = null;
  public searchValue = '';
  public userData = null;
  public P2PItemId = null;
  public userId = null;
  public searchedUserData = null;
  public searchedName ='';
  public searchedEmail = '';

  public auctionCampaign = null;
  public bid = null;
  public readMoreOptions = null;
  public bidderAddress = null;

  public showInfo = false;
  public showStreetAddress = false;
  public showPhone = false;
  public showAdditionalInfo = false;
  public showAdditionalInfoDesc = false;

  constructor(
    private modalAuctionUpdateEmailService: ModalAuctionUpdateEmailService,
    private auctionManageService: AuctionManageService,
    private fb: UntypedFormBuilder,
    private modalService: MdbModalService,
    private store: Store,
    private donorService: DonorService,
    private emailNameSpliter: EmailNameSpliterService,
  ) { }

  ngOnInit(): void {
    this.auctionCampaign = this.data.auctionCampaign;
    this.bid = this.data.bid;

    this.form = this.fb.group({
      'nameInput' : ['', [Validators.required]],
      'emailInput': ['', [
        Validators.required, 
        Validators.pattern(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)
      ]]
    });

    this.nameInput = this.form.get('nameInput') as UntypedFormControl;
    this.nameInput.setValue(this.bid.userInfo.name);
    this.emailInput = this.form.get('emailInput') as UntypedFormControl;
    this.emailInput.setValue(this.bid.userInfo.email);

    this.nameInput.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value)=> {
      this.searchDonor(value, 1);
      this.isAddActive = true;
      this.userId = null;
    })
    this.emailInput.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value)=> {
      this.searchDonor(value, 0);
      this.isAddActive = true;
      this.userId = null;
    })

    const addressText = window['utils'].getStreetAddressText(this.bid.userInfo.address);
    this.bidderAddress = addressText;
    
    this.readMoreOptions = {
      webkitLineClamp: [2,3,3,3,3],
    }
    
    this.getShowInfo();
  }

  getShowInfo() {
    const auctionCampaign = this.auctionCampaign;
    const bid = this.bid;

    this.showPhone = auctionCampaign.phoneNumRequired && bid.userInfo.phone;
    this.showStreetAddress = auctionCampaign.streetAddressRequired && this.bidderAddress;
    this.showAdditionalInfo = auctionCampaign.additionalInfoDesc && bid.additionalInfo;
    this.showAdditionalInfoDesc = auctionCampaign.additionalInfoSelectDesc && bid.additionalInfoSelect;

    if(this.showPhone || this.showStreetAddress || this.showAdditionalInfo || this.showAdditionalInfoDesc) {
        this.showInfo = true;
    } else {
      this.showInfo = false;
    }
  }

  searchDonor(value, name) {
    if(value.length > 1) {
      this.donorService.search(value, name)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((userProfiles) => {
          this.allProfiles = userProfiles;
          this.search(value)
      });
    }
  }

  search(searchValue) {
    let profileInfo = this.allProfiles.usersProfile.map(data => ({
      "data": data,
      "searchString": data.name + "/" + data.email
    }));

    let searchString = profileInfo.map(item => item.searchString);
    this.userData = profileInfo.map(item => item.data);

    let filteredResult = searchString.filter((item)=>item.toLowerCase().includes(searchValue))

    if(filteredResult.length === 0)
      this.notFound = true
    else
      this.notFound = false;
      
    this.resultsOptions = of(filteredResult);
  }

  passOption(event: MouseEvent | KeyboardEvent){
    let searchString: string = '';

    if (event instanceof MouseEvent) {
      searchString = (event.target as HTMLElement).innerText;
    }
  
    if (event instanceof KeyboardEvent && event.target instanceof HTMLInputElement) {
      searchString = event.target.value;
    }
  
    const [name, email] = this.emailNameSpliter.getNameAndEmail(searchString, true);
    // const [name, email] = searchString.split("/");

    this.nameInput.setValue(name, {emitEvent: false})
    this.emailInput.setValue(email, {emitEvent: false})

    this.searchedUserData = this.userData.filter((item)=>
      item.name.toLowerCase().includes(name.toLowerCase()) &&
      item.email.toLowerCase().includes(email.toLowerCase())
    );

    this.userId = this.searchedUserData[0].id;
    this.searchedName = this.searchedUserData[0].name;
    this.searchedEmail = this.searchedUserData[0].email;
  }

  onClickUpdate() {
    if(this.form.status === 'INVALID') {
      this.form.markAllAsTouched();
      return false
    }

    const isAutoBid = _.has(this.bid, 'isAutoBid') ? false : true;

    let param = ''
    if(isAutoBid) {
      param = 'autoBidId';
    } else {
      param = 'bidId';
    }

    const params = { }

    if (this.userId !== null && (this.nameInput.value === this.searchedName || this.emailInput.value === this.searchedEmail)) {
      params['newUserId'] = this.userId;
    } else {
      params['newName'] = this.nameInput.value;
      params['newEmail'] = this.emailInput.value;
    }

    params[`${param}`] = this.bid.id;

    this.modalRef =  this.modalService.open(ConfirmModalComponent, {
      ignoreBackdropClick: true,
      modalClass:'modal--paybee modal-sm',
      containerClass:'mdb-modal-backdrop-paybee',
      data: {
        title: 'Are you sure?',
        text: `All bids and auto bids for <b>${this.bid.userInfo.name}</b> will be updated to the new name or email.`,
        onClose: (status)=>{
          this.modalRef.close()
          if(status){
            const loadItemParams = {
              auctionType: this.auctionCampaign.campaignTypeData.auctionType,
              campaignId: this.auctionCampaign.id,
              presetId: this.bid.presetId,
              status: this.auctionCampaign.campaignTypeData.auctionStatus
            }

            this.store.dispatch({
              type: updateBidder.type,
              payload: {
                params: params,
                campaignId: this.auctionCampaign.id,
                loadItemParams: loadItemParams
              }
            });

            this.close();
          }
        }
      }
    });
  }

  close() {
    this.modalAuctionUpdateEmailService.close();
  }
}
